const baseRoute = 'survey/:moduleBridgeHex/';
export default {
  user_module_survey_home: {
    path: `${baseRoute}home/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
